/**
 * Time-dependent delivery text: the USP under the buy button (delivery_usp block in
 * sections/main-product.liquid) and the line on product cards and in the cart
 * (snippets/product-deliverytime.liquid). This sets html[data-bx-delivery="early"|"tomorrow"|"monday"]
 * based on the Dutch time, and the CSS in src/styles/app.css shows the matching line. Working off the
 * <html> element means markup swapped in later (variant change, filters, cart drawer) needs no re-run.
 */
const SELECTOR = '.bx-delivery-usp[data-cutoff]';
const DEFAULT_CUTOFF = '10:00';
const TIME_ZONE = 'Europe/Amsterdam';
const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
const NEXT_DAY_WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu'];

function parseCutoff(value) {
  const match = /^(\d{1,2})[:.](\d{2})$/.exec((value || '').trim());
  if (!match) return null;
  return parseInt(match[1], 10) * 60 + parseInt(match[2], 10);
}

function dutchNow() {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: TIME_ZONE,
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date());
  const get = (type) => (parts.find((p) => p.type === type) || {}).value;
  return {
    weekday: get('weekday'),
    minutes: parseInt(get('hour'), 10) * 60 + parseInt(get('minute'), 10),
  };
}

function update() {
  const usp = document.querySelector(SELECTOR);
  const cutoff = parseCutoff(usp ? usp.dataset.cutoff : DEFAULT_CUTOFF);
  const now = dutchNow();
  const early =
    cutoff !== null &&
    !Number.isNaN(now.minutes) &&
    WEEKDAYS.includes(now.weekday) &&
    now.minutes < cutoff;
  let state = 'monday';
  if (early) state = 'early';
  else if (NEXT_DAY_WEEKDAYS.includes(now.weekday)) state = 'tomorrow';
  document.documentElement.dataset.bxDelivery = state;
}

export function initDeliveryUsp() {
  try {
    update();
  } catch (e) {
    return;
  }
  // Flip over when the cut-off passes while the page is open.
  window.setInterval(update, 60 * 1000);
}
